module.exports = __webpack_public_path__ + "img/ok-icon.47515e92.svg";